import React from 'react'
import { Flex } from 'antd-mobile'

export default ({ children }) => (
  <Flex style={{ height: '100%' }} justify="center">
    {children}
  </Flex>
)
